var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.768,
    height: 68.267,
    viewBox: "0 0 68.768 68.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1737",
    "data-name": "Group 1737",
    transform: "translate(-335.512 -1209.932)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1735",
    "data-name": "Group 1735",
    transform: "translate(337.006 1211.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    d: "M136.979,1.129c-.05.817.07,1.7,0,2.51-.134,1.553-.573,3.749-.859,5.339-2.379,13.235-8.157,26.175-18.736,34.766,6.493,11.162-4.575,19.978-14.858,21.38-1.531.209-4.526.76-4.126-1.773.086-.542,1.43-1.86,1.843-2.551a10.316,10.316,0,0,0,1.052-2.4c.218-.8.942-4.486-.307-4.544-2.521.7-5.467,2.307-8.047,2.619-.609.074-2.14-.265-2.236-.205-.159.1-1.6,2.614-2.043,3.144-2.75,3.274-7.329,4.622-11.417,5.368-1.067.194-3.487.694-4.425.445a1.618,1.618,0,0,1-1.108-1.73c-.027-4.5,2.386-12.182,5.9-15.136.53-.445,3.044-1.884,3.144-2.044.12-.193-.22-.99-.246-1.338-.11-1.454,1.161-4.808,1.683-6.315.754-2.18,2.216-3.594-1.445-3.328a10.783,10.783,0,0,0-4.521,1.441c-.691.413-2.008,1.758-2.55,1.844-2.819.446-1.894-3.545-1.592-5.2C73.9,23.446,82.537,13.367,93.277,19.632,101.163,9.912,112.8,4.186,124.9,1.52a67.056,67.056,0,0,1,7.925-1.33c1.471-.141,3.422-.65,4.155.94",
    transform: "translate(-71.695 0.001)",
    fill: "#fff",
    stroke: "#2a77eb",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1736",
    "data-name": "Group 1736",
    transform: "translate(340.232 1214.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M240.393,75.931c10.075-.353,10.777,14.7,1.36,15.647-11.233,1.128-11.785-15.281-1.36-15.647m-.8,3.291c-4.7.742-4.836,8.449.16,9.179,7.355,1.074,7.463-10.383-.16-9.179",
    transform: "translate(-202.617 -63.336)",
    fill: "#2a77eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M212.652,148.295a1.579,1.579,0,0,1,1.959,2.116,16.627,16.627,0,0,1-2.8,3,1.632,1.632,0,0,1-2.293-2.137,17.417,17.417,0,0,1,3.134-2.982",
    transform: "translate(-183.987 -120.483)",
    fill: "#2a77eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M188.62,182.59c-1.373-1.374.65-3.774,2.222-2.3,1.625,1.522-.8,3.726-2.222,2.3",
    transform: "translate(-167.23 -145.458)",
    fill: "#2a77eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M98.459,111.405c-3.009-1.295-6.5-.444-9.409.784,1.245-7.132,7.745-16.3,15.838-11.376a60.3,60.3,0,0,0-6.429,10.592",
    transform: "translate(-88.892 -81.907)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M223,234.586c1.187-2.876,2.122-6.453.784-9.411a60.286,60.286,0,0,0,10.59-6.431c4.923,8.127-4.248,14.575-11.373,15.842",
    transform: "translate(-194.765 -176.218)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M88.3,246.685c.59-4.108,1.484-8.923,5.033-11.519.542-.4,2.2-1.551,2.806-1.271l4.948,4.949c.223.482-.323,1.313-.582,1.77-2.5,4.417-7.57,5.407-12.205,6.072",
    transform: "translate(-88.296 -188.158)",
    fill: "#fcdb77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M315.923,15.868a82.441,82.441,0,0,1-2.668,13.65L302.277,18.769c-.052-.345.055-.183.229-.236a69.938,69.938,0,0,1,13.418-2.665",
    transform: "translate(-257.413 -15.868)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M143.6,196.566c-1.88.375-4.061,1.593-5.924,1.853a1.744,1.744,0,0,1-1.452-.515,68.932,68.932,0,0,1-6.9-6.9,1.957,1.957,0,0,1-.619-1.4l1.879-6.059Z",
    transform: "translate(-120.227 -148.397)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M251.308,91.318c7.623-1.2,7.515,10.253.16,9.179-5-.729-4.856-8.437-.16-9.179",
    transform: "translate(-214.328 -75.432)",
    fill: "#fa0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonProject);
export default __webpack_public_path__ + "static/media/lesson_project.6e70bfad597950ca56e778a8e2ec7de0.svg";
export { ForwardRef as ReactComponent };